// Simple language context: reads ?lang=xx query, persists to localStorage, exposes hook.
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { T, LANGUAGES } from './mock/data';

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const q = params.get('lang');
    if (q && LANGUAGES.find(l => l.code === q)) return q;
    const stored = localStorage.getItem('yup_lang');
    if (stored && LANGUAGES.find(l => l.code === stored)) return stored;
    return 'it';
  });

  const setLang = useCallback((newLang) => {
    localStorage.setItem('yup_lang', newLang);
    setLangState(newLang);
    const url = new URL(window.location.href);
    url.searchParams.set('lang', newLang);
    window.history.replaceState({}, '', url.toString());
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
    const info = LANGUAGES.find(l => l.code === lang);
    document.documentElement.dir = info?.rtl ? 'rtl' : 'ltr';
  }, [lang]);

  const t = useCallback((key) => (T[lang] && T[lang][key]) || (T.en[key] || key), [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside LangProvider');
  return ctx;
}
